import { render, staticRenderFns } from "./OverviewNews.vue?vue&type=template&id=7eaf3694&scoped=true"
import script from "./OverviewNews.vue?vue&type=script&lang=js"
export * from "./OverviewNews.vue?vue&type=script&lang=js"
import style0 from "./OverviewNews.vue?vue&type=style&index=0&id=7eaf3694&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7eaf3694",
  null
  
)

export default component.exports